import React, { useState, useEffect } from "react";

import Autocomplete from "../ui/Autocomplete";
import NuxeoClient from "../../clients/NuxeoClient";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";

import { useI18n } from "../../I18nProvider";

export default function Channel(props) {
  const appText = useI18n();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    _loadChannelDetails();
  }, []);

  async function _loadChannelDetails() {
    await NuxeoClient.instance()
      .fetchMarketingChannels()
      .then((response) => {
        props.handleChange("fetchedMarketingChannels", response);
        setIsLoading(false);
      });
  }

  const handleChange = (marketingChannel) => {
    props.handleChange("marketingChannel", marketingChannel.label);
    props.handleChange("marketingChennalID", marketingChannel.id);
  };

  return (
    <Tooltip arrow title={appText.T276}>
      <Grid item={true} xs={12}>
        <div id="marketingChannel">
          <InputLabel className="field-label field-dropdown" required>
            {/* Marketing Channel */}
            {appText.T255}
          </InputLabel>
          <Autocomplete
            type={"single"}
            handleChange={handleChange}
            data={props.fetchedData}
            dataType={"marketingChannel"}
            mapVariable={"label"}
            value={props.value}
            isLoading={isLoading}
          />
        </div>
      </Grid>
    </Tooltip>
  );
}
